// Message handler for roomClient
import Logger from "./Logger";
import store from "../store";
import {
  activeRequestAcceptedHandler,
  activeRequestRejectedHandler,
  activeSpeakerHandler,
  allowedSwitchToHostHandler,
  changedConsumeLangHandler,
  changedProduceLangHandler,
  connectionStrengthHandler,
  currentConferenceStateHandler,
  maxParticipantsHandler,
  passiveRequestAcceptedHandler,
  passiveRequestRejectedHandler,
  peerMuteHandler,
  peerOnAirHandler,
  peerVideoMuteHandler,
  presentationStartedHandler,
  presentationStoppedHandler,
  remoteOffAirHandler,
  reqToSpeakOngoingHandler,
  setHandRaisedHandler,
  setLastAliveHandler,
  setSpotlightHandler,
  switchToHostHandler,
  switchToViewerHandler,
} from "./utils/conferenceHandlers";
import { newUserHandler, remoteCloseHandler, userCloseHandler } from "./utils/userHandlers";

const logger = new Logger("messageHandler.js");

export default (roomClient, msgData) => {
  logger.info("📩 Message Received 📩", msgData);

  if (msgData.peerId !== roomClient._peerId && msgData.peerId !== "all") return;

  switch (msgData.command) {
    case "server_started":
      roomClient.close();
      break;
    case "router":
      roomClient.getSctpAndSendBackToServer(msgData);
      break;
    case "transport_created":
      roomClient.initTransportsAndSendDtls(msgData);
      break;
    case "producer_id":
      roomClient.storeProducer(msgData);
      break;
    case "new_consumer":
      roomClient.initConsumer(msgData);
      break;
    case "new_data_consumer":
      roomClient.createDataConsumer(msgData);
      break;
    case "unpause_client_consumer":
      roomClient.startConsumer(msgData);
      break;
    case "new_user":
      newUserHandler(msgData, store, roomClient);
      break;
    case "user_close":
      userCloseHandler(msgData, store, roomClient);
      break;
    case "remote_close":
      remoteCloseHandler(msgData, roomClient);
      break;
    case "max_participants":
      maxParticipantsHandler(store);
      break;
    case "set_hand_raised":
      setHandRaisedHandler(msgData, store);
      break;
    case "peer_mute":
      peerMuteHandler(msgData, store, roomClient);
      break;
    case "peer_video_mute":
      peerVideoMuteHandler(msgData, store, roomClient);
      break;
    case "remote_mute":
      roomClient.muteMic();
      break;
    case "remote_video_mute":
      roomClient.videoMute();
      break;
    case "peer_onAir":
      peerOnAirHandler(msgData, store, roomClient);
      break;
    case "presentation_started":
      presentationStartedHandler(msgData, store);
      break;
    case "presentation_stopped":
      presentationStoppedHandler(msgData, store, roomClient);
      break;
    case "current_conference_state":
      currentConferenceStateHandler(msgData, store);
      break;
    case "set_spotlight":
      setSpotlightHandler(msgData, store);
      break;
    case "changed_produceLang":
      changedProduceLangHandler(msgData, store, roomClient);
      break;
    case "changed_consumeLang":
      changedConsumeLangHandler(msgData, store, roomClient);
      break;
    case "remote_offAir":
      remoteOffAirHandler(msgData, store, roomClient);
      break;
    case "active_handover_request":
      roomClient.setHandoverData(msgData);
      break;
    case "active_request_accepted":
      activeRequestAcceptedHandler(msgData, store);
      break;
    case "active_request_rejected":
      activeRequestRejectedHandler(msgData, store);
      break;
    case "passive_handover_request":
      roomClient.setHandoverData(msgData);
      break;
    case "passive_request_accepted":
      passiveRequestAcceptedHandler(msgData, store);
      break;
    case "passive_request_rejected":
      passiveRequestRejectedHandler(msgData, store);
      break;
    case "allowed_switchToHost":
      allowedSwitchToHostHandler(msgData, store);
      break;
    case "switched_toHost":
      switchToHostHandler(msgData, store);
      break;
    case "switch_to_viewer":
      switchToViewerHandler(msgData, store, roomClient);
      break;
    case "request_to_speak_ongoing":
      reqToSpeakOngoingHandler(msgData, store);
      break;
    case "activeSpeaker":
      activeSpeakerHandler(msgData, store);
      break;
    case "change_resolution":
      roomClient.changeWebcamResolution(msgData.resolution);
      break;
    case "toggle_resolution":
      roomClient.toggleMaxlayers();
      break;
    case "toggle_layers":
      break;
    case "set_preferedConsumerLayer":
      roomClient.setConsumerPreferredLayers(msgData.consumerId, msgData.spatialLayer, msgData.temporalLayer);
      break;
    // case "set_maxSendingLayer":
    //   roomClient.setMaxSendingSpatialLayer(msgData.layer)
    //   break;
    case "connection_strength":
      connectionStrengthHandler(msgData, store);
      break;
    case "set_lastAlive":
      setLastAliveHandler(msgData, store);
      break;
  }
};
